import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Flower2 } from "lucide-react";
import { api } from "@/components/Common";
import { Page, PageHeader, Loading, ErrorNote, RichText } from "@/components/Common";

export function GenresPage() {
  const [genres, setGenres] = useState(null);
  useEffect(() => {
    api.get("/genres").then((r) => setGenres(r.data)).catch(() => setGenres([]));
  }, []);

  return (
    <Page>
      <PageHeader title="اصنافِ ادب" subtitle="شعری و نثری اصناف کا فنی تعارف" crumbs={[{ label: "اصنافِ ادب" }]} />
      {!genres ? (
        <Loading />
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" data-testid="genres-grid">
          {genres.map((g) => (
            <Link
              key={g.slug}
              to={`/genres/${g.slug}`}
              data-testid={`genre-card-${g.slug}`}
              className="group bg-[#fdfbf7] border border-[#d4af37]/40 rounded-xl p-5 text-center transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(42,21,8,0.12)] hover:border-[#d4af37]"
            >
              <Flower2 size={22} className="mx-auto text-[#c5a059] group-hover:text-[#2a1508] transition-colors" />
              <h3 className="mt-3 text-xl font-semibold text-[#2a1508] leading-[2]">{g.title}</h3>
              <p className="text-sm text-[#5c3a21] mt-1 leading-[2] line-clamp-3">{g.desc}</p>
            </Link>
          ))}
        </div>
      )}
    </Page>
  );
}

export function GenrePage() {
  const { slug } = useParams();
  const [genre, setGenre] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setGenre(null);
    setErr(false);
    api.get(`/genres/${slug}`).then((r) => setGenre(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) return <Page><ErrorNote message="صنف نہیں ملی" /></Page>;
  if (!genre) return <Page><Loading /></Page>;

  return (
    <Page>
      <PageHeader title={genre.title} subtitle={genre.desc} crumbs={[{ label: "اصنافِ ادب", to: "/genres" }, { label: genre.title }]} />
      <div className="bg-[#fdfbf7] border border-[#d4af37]/40 rounded-2xl p-6 sm:p-10 shadow-[0_4px_20px_rgba(42,21,8,0.06)]" data-testid="genre-content">
        <RichText text={genre.content} />
      </div>
      {genre.works?.length > 0 && (
        <div className="mt-10">
          <h3 className="text-2xl font-bold text-[#2a1508] leading-[2] mb-4">متعلقہ متون</h3>
          <div className="grid sm:grid-cols-2 gap-4">
            {genre.works.map((w) => (
              <Link key={w.slug} to={`/works/${w.slug}`} data-testid={`genre-work-${w.slug}`} className="bg-[#fdfbf7] border border-[#d4af37]/40 rounded-xl px-5 py-4 text-lg text-[#2a1508] leading-[2] hover:border-[#d4af37] hover:-translate-y-0.5 transition-all duration-300">
                {w.title}
              </Link>
            ))}
          </div>
        </div>
      )}
    </Page>
  );
}
